import { Sites } from '@ps/platform-message-framework/common/Sites';
import { FeatureFlag } from '@ps/web-core-enums';
import classNames from 'clsx';
import React from 'react';
import { useForm } from 'react-final-form';
import { useSelector } from 'react-redux';

import useFeature from '@swf/core/hooks/useFeature';
import useWizardExit from '@swf/core/hooks/useWizardExit';
import { select } from '@swf/core/store';

import Prompt from '../../../../../Prompt/Prompt';
import TransitionProgressPrompt from '../../../../../TransitionProgressPrompt/TransitionProgressPrompt';

import {
  TXTCLI_Deposit,
  TXTCLI_Explore_PokerStars,
  TXTCLI_Verify_My_Account,
  TXTCLI_Verify_account,
  TXTWCL_Almost_there,
  TXTWCL_Continue_to_deposit,
  TXTWCL_Next_upXX,
  TXTWCL_Thank_You
} from './Celebration.messages.json';
import { promptButton, promptButtons } from './Celebration.scss';
import ES from './components/ES/ES';
import FR from './components/FR/FR';
import IT from './components/IT/IT';
import RO from './components/RO/RO';

export const getContent = (siteId: Sites) => {
  switch (siteId) {
    case Sites.ROM:
      return <RO />;
    case Sites.FRA:
      return <FR />;
    case Sites.ITA:
      return <IT />;
    case Sites.SPA:
      return <ES />;
    default:
      return null;
  }
};

const Celebration: React.FC = () => {
  const form = useForm();
  const exploreCTAEnabled = useFeature(FeatureFlag.SwcExploreCta);
  const depositReverseCTAVerify = useFeature(FeatureFlag.DepositReverseCTAVerify);
  const isNewTransitionEnabled = useFeature(FeatureFlag.SwcSignupRmfEcoEransitionTwo);
  const siteId = useSelector(select.cms.getSiteId);
  const isSpain = siteId === Sites.SPA;
  const content = getContent(siteId);
  const exitWizard = useWizardExit();

  const getPromptTitle = () => (isSpain ? TXTWCL_Thank_You : TXTWCL_Almost_there);

  const getPrimaryButtonTitle = () => {
    if (depositReverseCTAVerify) {
      return isSpain ? TXTCLI_Verify_My_Account : TXTCLI_Verify_account;
    }
    return isSpain ? TXTWCL_Continue_to_deposit : TXTCLI_Deposit;
  };

  const getSecondaryButtonButtonTitle = () => {
    if (depositReverseCTAVerify) {
      return isSpain ? TXTWCL_Continue_to_deposit : TXTCLI_Deposit;
    }
    return isSpain ? TXTCLI_Verify_My_Account : TXTCLI_Verify_account;
  };

  return content && !isNewTransitionEnabled ? (
    <Prompt
      noCloseButton
      variant="celebration"
      title={{ translation: getPromptTitle() }}
      secondaryTitle={isSpain ? undefined : { translation: TXTWCL_Next_upXX }}
      primaryButton={{
        translation: getPrimaryButtonTitle()
      }}
      secondaryButton={{
        translation: getSecondaryButtonButtonTitle()
      }}
      {...(!depositReverseCTAVerify && { onPrimaryButtonClick: () => form.submit() })}
      {...(depositReverseCTAVerify && { onSecondaryButtonClick: () => form.submit() })}
      classes={{ buttons: classNames(promptButtons, promptButton) }}
      {...(exploreCTAEnabled && {
        showLinkButton: true,
        onLinkButton: exitWizard,
        linkButton: { translation: TXTCLI_Explore_PokerStars }
      })}
    >
      {content}
    </Prompt>
  ) : content && isNewTransitionEnabled ? (
    <TransitionProgressPrompt
      title={{ translation: getPromptTitle() }}
      primaryButton={{
        translation: getPrimaryButtonTitle()
      }}
      secondaryButton={{
        translation: getSecondaryButtonButtonTitle()
      }}
      {...(!depositReverseCTAVerify && { onPrimaryButtonClick: () => form.submit() })}
      {...(depositReverseCTAVerify && { onSecondaryButtonClick: () => form.submit() })}
    >
      {content}
    </TransitionProgressPrompt>
  ) : null;
};

export default Celebration;
